MycompanyRouting.$inject = ["$urlRouterProvider", "$stateProvider"];

function MycompanyRouting($urlRouterProvider, $stateProvider) {

    $urlRouterProvider.otherwise("/Mycompany/Add");

    $stateProvider

        .state('Mycompany', {

            abstract: true,

            url: '/Mycompany',

            template: '<ui-view id="Mycompany"></ui-view>'

        })

        .state('Mycompany.Add', {

            url: '/Add',

            controller: 'Mycompany.AddController',

            controllerAs: 'self',

            templateProvider: ['$q', ($q) => {

                return $q((resolve) => {

                    require.ensure([], () => {

                        let template = require('./Add/views/index.html');

                        resolve(template);

                    });

                });

            }],

            resolve: {

                Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

                    let deferred = $q.defer();

                    require.ensure([], function () {

                        let module = require('./Add/Add.module');

                        $ocLazyLoad.load({

                            name: 'AddModule',

                        });

                        deferred.resolve(module);

                    });

                    return deferred.promise;

                }]

            },
            breadcrumbData: {
                parent: "Mycompany.List",
                title: "ثبت نام شرکت",
                icon: "fas fa-plus"
            }


        })
        .state('Mycompany.List', {

            url: '/List',

            controller: 'Mycompany.ListController',

            controllerAs: 'self',

            templateProvider: ['$q', ($q) => {

                return $q((resolve) => {

                    require.ensure([], () => {

                        let template = require('./List/views/index.html');

                        resolve(template);

                    });

                });

            }],

            resolve: {

                Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

                    let deferred = $q.defer();

                    require.ensure([], function () {

                        let module = require('./List/List.module');

                        $ocLazyLoad.load({

                            name: 'ListModule',

                        });

                        deferred.resolve(module);

                    });

                    return deferred.promise;

                }]

            },
            breadcrumbData: {
                parent: "GeneralInfo.List",
                title: "شرکت های من",
                icon: "fas fa-tasks"
            }

        })
        .state('Mycompany.Edit', {

            url: '/Edit/:id',

            controller: 'Mycompany.EditController',

            controllerAs: 'self',

            templateProvider: ['$q', ($q) => {

                return $q((resolve) => {

                    require.ensure([], () => {

                        let template = require('./Edit/views/index.html');

                        resolve(template);

                    });

                });

            }],

            resolve: {

                Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

                    let deferred = $q.defer();

                    require.ensure([], function () {

                        let module = require('./Edit/Edit.module');

                        $ocLazyLoad.load({

                            name: 'EditModule',

                        });

                        deferred.resolve(module);

                    });

                    return deferred.promise;

                }]

            },
            breadcrumbData: {
                parent: "Mycompany.List",
                title: "ویرایش اطلاعات کارمند",
                icon: "fas fa-tasks"
            }


        })
        .state('Mycompany.EmployeeFamily', {

            url: '/EmployeeFamily/:id',

            controller: 'Mycompany.EmployeeFamilyController',

            controllerAs: 'self',

            templateProvider: ['$q', ($q) => {

                return $q((resolve) => {

                    require.ensure([], () => {

                        let template = require('./EmployeeFamily/views/index.html');

                        resolve(template);

                    });

                });

            }],

            resolve: {

                Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

                    let deferred = $q.defer();

                    require.ensure([], function () {

                        let module = require('./EmployeeFamily/EmployeeFamily.module');

                        $ocLazyLoad.load({

                            name: 'EmployeeFamilyModule',

                        });

                        deferred.resolve(module);

                    });

                    return deferred.promise;

                }]

            },
            breadcrumbData: {
                parent: "Mycompany.List",
                title: "لیست اعضای خانواده کارمند",
                icon: "fas fa-list"
            }


        })
        .state('Mycompany.AddEmployeeFamily', {

            url: '/AddEmployeeFamily/:id',

            controller: 'Mycompany.AddEmployeeFamilyController',

            controllerAs: 'self',

            templateProvider: ['$q', ($q) => {

                return $q((resolve) => {

                    require.ensure([], () => {

                        let template = require('./AddEmployeeFamily/views/index.html');

                        resolve(template);

                    });

                });

            }],

            resolve: {

                Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

                    let deferred = $q.defer();

                    require.ensure([], function () {

                        let module = require('./AddEmployeeFamily/AddEmployeeFamily.module');

                        $ocLazyLoad.load({

                            name: 'AddEmployeeFamilyModule',

                        });

                        deferred.resolve(module);

                    });

                    return deferred.promise;

                }]

            },
            breadcrumbData: {
                parent: "Mycompany.EmployeeFamily",
                title: "فزودن اطلاعات خانواده",
                icon: "fas fa-plus"
            }


        })
        .state('Mycompany.EditEmployeeFamily', {

            url: '/EditEmployeeFamily/:employeeId/:familyId',

            controller: 'Mycompany.EditEmployeeFamilyController',

            controllerAs: 'self',

            templateProvider: ['$q', ($q) => {

                return $q((resolve) => {

                    require.ensure([], () => {

                        let template = require('./EditEmployeeFamily/views/index.html');

                        resolve(template);

                    });

                });

            }],

            resolve: {

                Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

                    let deferred = $q.defer();

                    require.ensure([], function () {

                        let module = require('./EditEmployeeFamily/EditEmployeeFamily.module');

                        $ocLazyLoad.load({

                            name: 'EditEmployeeFamilyModule',

                        });

                        deferred.resolve(module);

                    });

                    return deferred.promise;

                }]

            },
            breadcrumbData: {
                parent: "Mycompany.EmployeeFamily",
                title: "ویرایش اطلاعات",
                icon: "fas fa-edit"
            }



        })/*endOfResolve*/;

}



export default MycompanyRouting;
